// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3uojV","content":"styles_content__2Udyy","row":"styles_row__2GlyW","footer":"styles_footer__3fkbO","phraseLength":"styles_phraseLength__24oJq"};